"use client"

import RoughEmeraldsHeader from "./rough-emeralds-header"
import RoughEmeraldsGrid from "./rough-emeralds-grid"
import { useEffect } from "react"

export default function RoughEmeraldsPage() {
  useEffect(()=>{
    window.scrollTo(0,0);
  },[])
  return (
    <div className="min-h-screen bg-neutral-50">
      <RoughEmeraldsHeader />
      <RoughEmeraldsGrid />
    </div>
  )
}
